'use strict';
var _ = require('lodash');
var Backbone = require('backbone');
var CryptoJS = require('crypto-js');
var ModelConnect = require('tscom-connect');

module.exports = ModelConnect.extend({
    recaptchaUrl: ((location.host.indexOf('-local') > -1) ? '' : 'https://' + location.host) + '/vote.php',
    recaptchaGateActive: false,
    recaptchaToken: null,

    initialize: function(attr, options) {
        _.bindAll(this, 'syncSuccess', 'syncError');

        this.apiUrl = options.apiUrl;
        this.secretKey = options.secretKey;
        this.version_id = options.version_id;
        this.recaptchaGateActive = options.recaptchaGateActive;
        this.recaptchaUrl = options.recaptchaUrl;
    },

    unsetMultiple: function(arr,options) {
        arr.forEach(function(val){
            this.unset(val, options);
        }.bind(this));
    },

    urlRoot: function() {
        var isVote = this.get( 'action_type' ) === 'vote';
        var recaptchaActive = this.recaptchaGateActive;
        var apiUrl = isVote && recaptchaActive ? this.recaptchaUrl : this.apiUrl;
        var params = this.paramsLiteralToQsp(this.toJSON());

        return isVote ? apiUrl : apiUrl + '?' + params;
    },

    sync: function(crud, model, options) {
        var isVote = this.get( 'action_type' ) === 'vote';
        var recaptchaActive = this.recaptchaGateActive;
        var shouldAddStr = isVote && recaptchaActive;
        var params = {};

        if(!isVote) {

            var qsp = this.paramsLiteralToQsp(model.toJSON());
            var b64hash = this.qspToHash(qsp);

            params = {
                url: this.urlRoot(),
                type: 'POST',
                crossDomain: true,
                dataType: 'json',
                data: 'Authorization=' + encodeURIComponent(b64hash)
            };

        } else {

            if(shouldAddStr) {
                model.set({
                    'g-recaptcha-response': this.recaptchaToken
                });
            }

            params = {
                url: this.urlRoot(),
                headers: { 'content-type': 'application/json' },
                method: 'POST',
                crossDomain: true,
                dataType: 'json',
                data: JSON.stringify(model.toJSON())
            };
        }

        _.extend(params, model.toJSON(), options);

        return Backbone.sync(crud, model, params).done(this.syncSuccess).fail(this.syncFail);
    },

    /**
     * [ qspToHash override ]
     */
    qspToHash: function(data) {
        var secret = this.version_id + this.versionCheck;
        var binaryHash = CryptoJS.HmacSHA256(data, secret);
        var base64Hash = CryptoJS.enc.Base64.stringify(binaryHash);
        return base64Hash;
    },
});



// WEBPACK FOOTER //
// ./app/scripts/models/connect.js